import store from '@/store'
/**
 * 通过指令控制功能级权限
 * @param {*} el 
 * @param {*} binding 
 */
function checkPermission(el, binding) {
    const { value } = binding
    const roles = store.state.menuPerms;
    if (value && value instanceof Array) {
        if (value.length > 0) {
            const permissionRoles = value

            const hasPermission = roles.some(role => {
                return permissionRoles.includes(role)
            })
            if (!hasPermission) {
                el.parentNode && el.parentNode.removeChild(el)
            }
        }
    } else {
        throw new Error(`请输入角色! 例： v-permission="['admin','editor']"`)
    }
}

export default {
    inserted(el, binding) {
        checkPermission(el, binding)
    },
    update(el, binding) {
        checkPermission(el, binding)
    }
}


// WEBPACK FOOTER //
// ./src/components/cloud-clinic/directives/permission/index.js